import { useState } from "react";
import { 
  Calendar, ChevronLeft, ChevronRight, ChevronDown, Sparkles 
} from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

const MONTHS = [
  "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
  "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
];

export function TroquinhoCalendar({ currentMonth, currentYear, onPeriodChange }) {
  const [showMonthPicker, setShowMonthPicker] = useState(false);
  const [viewYear, setViewYear] = useState(currentYear); // Ano que está sendo visualizado no modal

  const handlePrev = () => {
    if (currentMonth === 0) {
      onPeriodChange(11, currentYear - 1);
    } else {
      onPeriodChange(currentMonth - 1, currentYear);
    }
  };

  const handleNext = () => {
    if (currentMonth === 11) {
      onPeriodChange(0, currentYear + 1);
    } else {
      onPeriodChange(currentMonth + 1, currentYear);
    }
  };

  const selectMonth = (month) => {
    onPeriodChange(month, viewYear);
    setShowMonthPicker(false);
  };

  const goToToday = () => {
    const today = new Date();
    onPeriodChange(today.getMonth(), today.getFullYear());
    setViewYear(today.getFullYear());
    setShowMonthPicker(false);
  };

  return (
    <div className="flex items-center gap-1.5">
      {/* Botão Anterior */}
      <Button
        variant="ghost"
        size="icon"
        className="w-10 h-10 rounded-full bg-white shadow-sm border border-slate-100"
        onClick={handlePrev}
      >
        <ChevronLeft className="w-5 h-5 text-slate-600" />
      </Button>
      
      {/* Seletor Central */}
      <Button
        variant="ghost"
        className="px-4 py-2 h-12 rounded-full bg-white shadow-sm font-semibold text-slate-700 flex items-center gap-3 border border-slate-100"
        onClick={() => {
            setViewYear(currentYear);
            setShowMonthPicker(true);
        }}
      >
        <Calendar className="w-4 h-4 text-indigo-500" />
        <div className="flex flex-col items-start leading-none mt-0.5">
          <span className="text-[11px] text-slate-400 font-semibold mb-0.5">Período</span>
          <span className="text-sm font-bold text-slate-700">{MONTHS[currentMonth]} {currentYear}</span>
        </div>
        <ChevronDown className="w-4 h-4 text-slate-400 ml-1" />
      </Button>
      
      {/* Botão Próximo */}
      <Button
        variant="ghost"
        size="icon"
        className="w-10 h-10 rounded-full bg-white shadow-sm border border-slate-100"
        onClick={handleNext}
      >
        <ChevronRight className="w-5 h-5 text-slate-600" />
      </Button>

      {/* Modal Picker */}
      <Dialog open={showMonthPicker} onOpenChange={setShowMonthPicker}>
        <DialogContent className="max-w-sm rounded-[32px] border-none shadow-2xl">
          <DialogHeader>
            <DialogTitle className="text-center text-xl font-medium text-slate-800">
              Selecionar Período
            </DialogTitle>
          </DialogHeader>
          
          <div className="space-y-6 py-4">
            {/* Seletor de Ano no Modal */}
            <div className="flex items-center justify-between bg-slate-100 rounded-2xl p-1">
              <Button variant="ghost" size="icon" onClick={() => setViewYear(v => v - 1)}>
                <ChevronLeft className="w-5 h-5 text-slate-600" />
              </Button>
              <span className="font-black text-slate-800 text-lg">{viewYear}</span>
              <Button variant="ghost" size="icon" onClick={() => setViewYear(v => v + 1)}>
                <ChevronRight className="w-5 h-5 text-slate-600" />
              </Button>
            </div>

            {/* Grid de Meses */}
            <div className="grid grid-cols-3 gap-3">
              {MONTHS.map((month, index) => {
                const isSelected = currentMonth === index && currentYear === viewYear;
                const isToday = new Date().getMonth() === index && new Date().getFullYear() === viewYear;
                
                return (
                  <Button
                    key={month}
                    variant="ghost"
                    className={`rounded-2xl h-12 font-bold transition-all ${
                      isSelected 
                        ? "bg-indigo-500 text-white shadow-lg shadow-indigo-200" 
                        : isToday 
                          ? "bg-sky-100 text-sky-700 hover:bg-sky-200" 
                          : "bg-slate-50 text-slate-600 hover:bg-slate-100"
                    }`}
                    onClick={() => selectMonth(index)}
                  >
                    {month.slice(0, 3)}
                  </Button>
                );
              })}
            </div>

            <Button 
              variant="outline" 
              className="w-full h-12 rounded-2xl font-bold border-2 border-slate-100 text-indigo-600 hover:bg-indigo-50"
              onClick={goToToday}
            >
              <Sparkles className="w-4 h-4 mr-2" />
              Ir para Mês Atual
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}